import { useContext } from "react";
import { Paper } from "@mui/material";
import { useEffect } from "react";
import { AppContext } from "../../../App";
import CheckoutAction from "./CheckoutAction";
import CartItems from "./CartItems";

const Cart = (props) => {
  const {
    cartItems,
    setCartItems,
    subTotal,
    setSubTotal,
    setTotalPay,
    setTax,
    taxPct,
  } = props;
  const { selStore, settings } = useContext(AppContext);

  useEffect(() => {
    if (selStore) {
      var _total = cartItems
        .map((j) => j.qty * j.price)
        .reduce((x, y) => x + y, 0);
      setSubTotal(parseFloat(_total.toFixed(settings.decimal)));

      var _taxItemTotal = cartItems
        .filter((j) => j.tax === 1)
        .map((j) => j.qty * j.price)
        .reduce((x, y) => x + y, 0)
        .toFixed(settings.decimal);
      var _tax = (parseFloat(taxPct) / 100) * _taxItemTotal;
      setTax(_tax);
      setTotalPay(parseFloat((_tax + _total).toFixed(settings.decimal)));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems, settings]);

  return settings ? (
    <Paper className="shadow-xs ">
      {/* ----------- Cart Items ----------- */}
      <CartItems {...{ cartItems, setCartItems }} />
      {/* ----------- Checkout Action ----------- */}
      <CheckoutAction {...{ subTotal }} />
    </Paper>
  ) : (
    "Loading..."
  );
};

export default Cart;
